/* eslint-disable no-empty */
import { ResponseBasketballGetOperationsCenter } from '@hefe/models';
import { createApi } from '@reduxjs/toolkit/query/react';
import API from '../../../api/api';

export const basketballOperationsCenterApi = createApi({
  reducerPath: 'basketballOperationsCenterApi',
  baseQuery: API.baseQuery,
  endpoints: (builder) => ({
    fetchData: builder.query<
      ResponseBasketballGetOperationsCenter,
      { from?: string; to?: string }
    >({
      query: (id) =>
        `v2/basketball/operations-center?from=${id.from || ''}&to=${
          id.to || ''
        }`,
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  reducerPath,
  reducer,
  middleware,
  useFetchDataQuery,
  useLazyFetchDataQuery,
} = basketballOperationsCenterApi;
